import { AxiosError } from "axios"

type TApiErrorBody = {
    displayMessage?: string
    // Validierungsfehler (validationErrorBody im Backend): { message: "Validation failed", displayMessage, details: [{ path, message }] }
    details?: { path?: string; message?: string }[]
}

/** Text für den Nutzer: zuerst die Meldungen eines Validierungsfehlers, dann `displayMessage`, sonst `fallback`. */
export const apiErrorText = (error: unknown, fallback: string) => {
    const body = (error as AxiosError<TApiErrorBody>)?.response?.data
    const details = body && Array.isArray(body.details) ? body.details : []
    const messages = details.map((issue) => issue.message).filter((message): message is string => !!message)
    if (messages.length > 0) return messages.join(" ")
    return body?.displayMessage || fallback
}

/** `displayMessage` aus dem Fehlerkörper des Backends `{code, success, message, displayMessage}`, sonst `undefined`. */
export const apiDisplayMessage = (error: unknown): string | undefined => {
    const body = (error as AxiosError<unknown>)?.response?.data
    if (!body || typeof body !== "object") return undefined
    const displayMessage = (body as TApiErrorBody).displayMessage
    return typeof displayMessage === "string" && displayMessage ? displayMessage : undefined
}

/**
 * Fehlertext für Toasts nach einer Aktion: der feste Text der Aktion (`fallback`) plus der Grund aus dem Backend (`displayMessage`),
 * z. B. 409 „Diese E-Mail-Adresse wird bereits verwendet“, 413 „Die Anfrage ist zu groß.“, 403 fehlendes Recht.
 * Validierungsdetails werden hier nicht angezeigt (technische Feldnamen); dafür gibt es `apiErrorText`.
 */
export const apiErrorMessage = (error: unknown, fallback: string) => {
    const displayMessage = apiDisplayMessage(error)
    if (!displayMessage || displayMessage === fallback) return fallback
    const head = /[.!?]$/.test(fallback.trim()) ? fallback.trim() : fallback.trim() + "."
    return `${head} ${displayMessage}`
}
